'use client'

import * as React from 'react'
import { tw } from 'utils/classnames'

import { useCarouselContext } from './context'

interface ContainerProps extends React.PropsWithChildren {
  children: React.ReactNode
  className?: string
}

export function Container({ children, className }: ContainerProps) {
  const { containerRef } = useCarouselContext()

  return (
    <div
      ref={containerRef}
      className={tw(
        'flex w-full snap-x snap-proximity gap-3 overflow-x-auto scroll-smooth pb-4',
        className,
      )}
    >
      {children}
    </div>
  )
}

Container.displayName = 'Carousel.Container'
